module.exports = __webpack_public_path__ + "img/Coin.e2287d84.png";